/* The sign-in page. `onSignIn` starts the Cardea authorization-code + PKCE
   redirect; this component only presents it.

   The prototype offered two demo buttons that swapped identity in place. They
   are deliberately absent: Milo distinguishes Sabrina from Rehman by which
   credential was presented, so an identity picker with no credential behind it
   could only ever lie. */
import { Button, Window } from '../ds'

export interface SignInProps {
  onSignIn: () => void
  /** Set while the redirect is being prepared, or when returning from Cardea. */
  busy?: boolean
  /** Shown when an authorization attempt failed. */
  error?: string | null
}

export function SignIn({ onSignIn, busy = false, error = null }: SignInProps) {
  return (
    <div className="milo-signin">
      <div className="milo-signin-bar">
        <span>milo.rayray.cloud</span>
        <span>Carry the calf ✦</span>
      </div>

      <div className="milo-signin-body">
        <h1 className="milo-signin-wordmark">MILO</h1>
        <p className="milo-signin-tagline">Weight / Tape / Macros / Coaching data</p>

        <Window
          title="CARDEA.AUTH"
          shadow="l"
          style={{ width: '100%', maxWidth: 400 }}
          bodyStyle={{ display: 'flex', flexDirection: 'column', gap: 14 }}
        >
          <p
            style={{
              margin: 0,
              textAlign: 'center',
              fontFamily: 'var(--lq-font-mono)',
              fontSize: 14,
              fontWeight: 700,
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
            }}
          >
            ✦ Speak friend and enter ✦
          </p>

          <Button variant="dark" size="lg" block onClick={onSignIn} disabled={busy}>
            {busy ? 'Signing in…' : 'Sign in'}
          </Button>

          {error ? (
            <p
              style={{
                margin: 0,
                fontSize: 13,
                fontWeight: 700,
                color: 'var(--lq-red)',
              }}
              role="alert"
            >
              × {error}
            </p>
          ) : null}
        </Window>
      </div>

      <p className="milo-signin-foot">
        Named for Milo of Croton ✦ Carry the calf daily
      </p>
    </div>
  )
}
